/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Print_ActionInputs */

const vi_tea_purchase_print_action = /** @type {(inputs: Tea_Purchase_Print_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In`)
};

/**

* @param {Tea_Purchase_Print_ActionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_print_action = /** @type {((inputs?: Tea_Purchase_Print_ActionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Print_ActionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_print_action(inputs)
});